import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

import Bg from "./bg";
export default class ScrollFunc {
    constructor() {
        //instances
        this.Bg = new Bg();

        this.init();
    }

    init() {
        this.onScroll();
        this.smoothScroll();
    }

    onScroll() {
        const that = this;
        const revealElm = document.querySelectorAll(".js-scrollreveal");
        const fadeinElm = document.querySelectorAll(".js-scrollfadein");
        const roseElm01 = document.querySelectorAll(".js-rose-01");
        const roseElm02 = document.querySelectorAll(".js-rose-02");
        const section = document.querySelectorAll(".js-section");

        revealElm.forEach((el) => {
            ScrollTrigger.create({
                trigger: el,
                start: "top 70%",
                onEnter: () => {
                    el.classList.add("-reveal");
                },
            });
        });

        fadeinElm.forEach((el) => {
            ScrollTrigger.create({
                trigger: el,
                start: "top bottom",
                end: "bottom top",
                toggleClass: {
                    targets: el,
                    className: "-scrollin",
                },
            });
        });

        roseElm01.forEach((el) => {
            ScrollTrigger.create({
                trigger: el,
                start: "top bottom",
                end: "bottom top",
                toggleClass: {
                    targets: el,
                    className: "-scrollin",
                },
            });
        });

        roseElm02.forEach((el) => {
            ScrollTrigger.create({
                trigger: el,
                start: "top bottom",
                end: "bottom top",
                toggleClass: {
                    targets: el,
                    className: "-scrollin",
                },
            });
        });

        section.forEach((el) => {
            const changeCurrent = () => {
                const sec = el.id;
                document.body.dataset.current = sec;
            };

            ScrollTrigger.create({
                trigger: el,
                start: "top center",
                end: "bottom center",
                onEnter: () => {
                    changeCurrent();
                },
                onEnterBack: () => {
                    changeCurrent();
                },
            });
        });

        ScrollTrigger.create({
            trigger: "#information",
            start: "top 50%",
            onEnter: () => {
                that.Bg.openModalWindow();
                document.querySelector(".mv__bnr").classList.add("-hide");
            },
            onLeaveBack: () => {
                that.Bg.closeModalWindow();
                document.body.dataset.current = "top";
                document.querySelector(".mv__bnr").classList.remove("-hide");
            },
        });
    }

    smoothScroll() {
        const triggers = document.querySelectorAll(".js-smoothscroll");

        triggers.forEach((el) => {
            el.addEventListener("click", (e) => {
                e.preventDefault();
                const hash = el.getAttribute("href");
                const offset = window.innerWidth <= 768 ? window.innerWidth * 0.3 : 200 * (window.innerWidth / 1920);
                gsap.to(window, { duration: 1, scrollTo: { y: hash, offsetY: offset }, ease: "circ.inOut" });
            });
        });
    }
}
